<template>
    <div>
        <div>
            <h1>实名认证</h1>
            <p>บริษัทฯ มุ่งเน้นความสำคัญในการคุ้มครองข้อมูลส่วนบุคคลของลูกค้าทุกราย โดยนโยบายความเป็นส่วนตัวฉบับนี้ ได้อธิบายแนวทางปฏิบัติเกี่ยวกับการเก็บรวบรวม การนำไปใช้ และ/หรือ การเปิดเผยข้อมูลส่วนบุคคล รวมถึงสิทธิต่าง ๆ ของเจ้าของข้อมูล ตามประกาศกฎหมายคุ้มครองข้อมูลส่วนบุคคล</p>
            <b-button variant="link" @click="ProtocolPrivacy = true">นโยบายความเป็นส่วนตัวสำหรับการยืนยันตัวตน</b-button>
        </div>
        <div>
            <b-form @submit="onSubmit">
                <b-form-group
                    id="input-group-1"
                    label="电话号码"
                    label-for="input-1"
                >
                    <b-form-input
                        id="input-1"
                        v-model="ruleForm.idcardTel"
                        placeholder="กรุณาเข้า"
                        required
                    ></b-form-input>
                </b-form-group>

                <b-form-group
                    id="input-group-1"
                    label="证件类型"
                    label-for="input-1"
                >
                    <b-form-radio-group
                        id="radio-group-1"
                        v-model="ruleForm.certType"
                        :options="options"
                        name="radio-options"
                    ></b-form-radio-group>
                </b-form-group>

                <b-form-group
                    id="input-group-1"
                    label="身份证姓名"
                    label-for="input-1"
                >
                    <b-form-input
                        id="input-1"
                        v-model="ruleForm.idcardName"
                        placeholder="กรุณาเข้า"
                        required
                    ></b-form-input>
                </b-form-group>

                <b-form-group
                    id="input-group-1"
                    label="身份证号码"
                    label-for="input-1"
                >
                    <b-form-input
                        id="input-1"
                        v-model="ruleForm.idcardNum"
                        placeholder="กรุณาเข้า"
                        required
                    ></b-form-input>
                </b-form-group>

                <b-form-group
                    id="input-group-1"
                    label="身份证正面照片"
                    label-for="input-1"
                >
                    <upload style="width: 300px" @updateImage="updateImage" :imageUrl="imgUrl"></upload>
                </b-form-group>

                <b-button type="submit" variant="primary">Submit</b-button>
            </b-form>
        </div>

        <b-modal
            centered
            hide-footer
            v-model="ProtocolPrivacy"
            size="lg"
            title="实名认证安全隐私协议"
        >
            <div class="noticeContent">
                <h3>Privacy Policy</h3>
                <p>บริษัทฯ มุ่งเน้นความสำคัญในการคุ้มครองข้อมูลส่วนบุคคลของลูกค้าทุกราย โดยนโยบายความเป็นส่วนตัวฉบับนี้ ได้อธิบายแนวทางปฏิบัติเกี่ยวกับการเก็บรวบรวม การนำไปใช้ และ/หรือ การเปิดเผยข้อมูลส่วนบุคคล รวมถึงสิทธิต่าง ๆ ของเจ้าของข้อมูล ตามประกาศกฎหมายคุ้มครองข้อมูลส่วนบุคคล</p>

                <h4>การเก็บรวบรวมข้อมูลส่วนบุคคล</h4>
                <p>บริษัทฯเก็บรวบรวมข้อมูลส่วนบุคคล ที่ได้รับโดยตรงจากลูกค้าผ่านช่องทางต่างๆ ดังนี้:</p>
                <p>การสมัครสมาชิก</p>
                <p>โทรศัพท์</p>
                <p>อีเมล</p>

                <h4>ประเภทข้อมูลส่วนบุคคลที่เก็บรวบรวม</h4>
                <p>ข้อมูลส่วนบุคคล </p>
                <p>เช่น ชื่อ นามสกุล อายุ วันเดือนปีเกิด สัญชาติ เลขประจำตัวประชาชน หนังสือเดินทาง เป็นต้น</p>
                <br>
                <p>ข้อมูลการติดต่อ </p>
                <p>เช่น ที่อยู่ หมายเลขโทรศัพท์ อีเมล เป็นต้น</p>
                <br>
                <p>ข้อมูลบัญชี </p>
                <p>เช่น บัญชีผู้ใช้งาน ประวัติการใช้งาน เป็นต้น</p>
                <br>
                <p>หลักฐานแสดงตัวตน </p>
                <p>เช่น สำเนาบัตรประจำตัวประชาชน สำเนาหนังสือเดินทาง เป็นต้น</p>
                <br>
                <p>ข้อมูลการทำธุรกรรมและการเงิน </p>
                <p>เช่น ประวัติการสั่งซื้อ รายละเอียดบัตรเครดิต บัญชีธนาคาร เป็นต้น</p>
                <br>
                <p>ข้อมูลทางเทคนิค </p>
                <p>เช่น IP Address, Cookie ID, ประวัติการใช้งานเว็บไซต์ (Activity Log) เป็นต้น</p>
                <br>
                <p>ข้อมูลอื่น ๆ </p>
                <p>เช่น รูปภาพ ภาพเคลื่อนไหว และข้อมูลอื่นใดที่ถือว่าเป็นข้อมูลส่วนบุคคลตามกฎหมายคุ้มครองข้อมูลส่วนบุคคล</p>
                <br>

                <h4>ผู้เยาว์</h4>
                <p>หากคุณมีอายุต่ำกว่า 20 ปีหรือมีข้อจำกัดความสามารถตามกฎหมาย เราอาจเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลของคุณ เราอาจจำเป็นต้องให้พ่อแม่หรือผู้ปกครองของคุณให้ความยินยอมหรือที่กฎหมายอนุญาตให้ทำได้ หากเราทราบว่ามีการเก็บรวบรวมข้อมูลส่วนบุคคลจากผู้เยาว์โดยไม่ได้รับความยินยอมจากพ่อแม่หรือผู้ปกครอง เราจะดำเนินการลบข้อมูลนั้นออกจากเซิร์ฟเวอร์ของเรา</p>

                <h4>วิธีการเก็บรักษาข้อมูลส่วนบุคคล</h4>
                <p>
                    เราจะเก็บรักษาข้อมูลส่วนบุคคลของคุณในรูปแบบเอกสารและรูปแบบอิเล็กทรอนิกส์
                </p>
                <p>เราเก็บรักษาข้อมูลส่วนบุคคลของคุณ ดังต่อไปนี้:</p>
                <p>เซิร์ฟเวอร์บริษัทของเราในประเทศไทย</p>
                <p>เซิร์ฟเวอร์บริษัทของเราในต่างประเทศ</p>
                <p>ผู้ให้บริการเซิร์ฟเวอร์ในต่างประเทศ</p>

                <h4>การประมวลผลข้อมูลส่วนบุคคล</h4>
                <p>เราจะเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลของคุณเพื่อวัตถุประสงค์ดังต่อไปนี้:</p>
                <p>เพื่อสร้างและจัดการบัญชีผู้ใช้งาน</p>
                <p>เพื่อจัดส่งสินค้าหรือบริการ</p>
                <p>เพื่อปรับปรุงสินค้า บริการ หรือประสบการณ์การใช้งาน</p>
                <p>เพื่อการบริหารจัดการภายในบริษัท</p>
                <p>เพื่อการตลาดและการส่งเสริมการขาย</p>
                <p>เพื่อการบริการหลังการขาย</p>
                <p>เพื่อรวบรวมข้อเสนอแนะ</p>
                <p>เพื่อชำระค่าสินค้าหรือบริการ</p>
                <p>เพื่อปฏิบัติตามข้อตกลงและเงื่อนไข (Terms and Conditions)</p>
                <p>เพื่อปฏิบัติตามกฎหมายและกฎระเบียบของหน่วยงานราชการ</p>

                <h4>การเปิดเผยข้อมูลส่วนบุคคล</h4>
                <p>เราอาจเปิดเผยข้อมูลส่วนบุคคลของคุณให้แก่ผู้อื่นภายใต้ความยินยอมของคุณหรือที่กฎหมายอนุญาตให้เปิดเผยได้ ดังต่อไปนี้</p>
                <h4>การบริหารจัดการภายในองค์กร</h4>
                <p>เราอาจเปิดเผยข้อมูลส่วนบุคคลของคุณภายในบริษัทเท่าที่จำเป็นเพื่อปรับปรุงและพัฒนาสินค้าหรือบริการของเรา เราอาจรวบรวมข้อมูลภายในสำหรับสินค้าหรือบริการต่าง ๆ ภายใต้นโยบายนี้เพื่อประโยชน์ของคุณและผู้อื่นมากขึ้น</p>
                <h4>ผู้ให้บริการ</h4>
                <p>เราอาจเปิดเผยข้อมูลส่วนบุคคลของคุณบางอย่างให้กับผู้ให้บริการของเราเท่าที่จำเป็นเพื่อดำเนินงานในด้านต่าง ๆ เช่น การชำระเงิน การตลาด การพัฒนาสินค้าหรือบริการ เป็นต้น ทั้งนี้ ผู้ให้บริการมีนโยบายความเป็นส่วนตัวของตนเอง</p>

                <h4>พันธมิตรทางธุรกิจ</h4>
                <p>เราอาจเปิดเผยข้อมูลบางอย่างกับพันธมิตรทางธุรกิจเพื่อติดต่อและประสานงานในการให้บริการสินค้าหรือบริการ และให้ข้อมูลเท่าที่จำเป็นเกี่ยวกับความพร้อมใช้งานของสินค้าหรือบริการ</p>
                <h4>การบังคับใช้กฎหมาย</h4>
                <p>ในกรณีที่มีกฎหมายหรือหน่วยงานราชการร้องขอ เราจะเปิดเผยข้อมูลส่วนบุคคลของคุณเท่าที่จำเป็นให้แก่หน่วยงานราชการ เช่น ศาล หน่วยงานราชการ เป็นต้น</p>
                <h4>การโอนข้อมูลส่วนบุคคลไปต่างประเทศ</h4>
                <p>เราอาจเปิดเผยหรือโอนข้อมูลส่วนบุคคลของคุณไปยังบุคคล องค์กร หรือเซิร์ฟเวอร์ (Server) ที่ตั้งอยู่ในต่างประเทศ โดยเราจะดำเนินการตามมาตรการต่าง ๆ เพื่อให้มั่นใจว่าการโอนข้อมูลส่วนบุคคลของคุณไปยังประเทศปลายทางนั้นมีมาตรฐานการคุ้มครองข้อมูลส่วนบุคคลอย่างเพียงพอ หรือกรณีอื่น ๆ ตามที่กฎหมายกำหนด</p>

                <h4>ระยะเวลาจัดเก็บข้อมูลส่วนบุคคล</h4>
                <p>เราจะเก็บรักษาข้อมูลส่วนบุคคลของคุณไว้ตามระยะเวลาที่จำเป็นในระหว่างที่คุณเป็นลูกค้าหรือมีความสัมพันธ์อยู่กับเราหรือตลอดระยะเวลาที่จำเป็นเพื่อให้บรรลุวัตถุประสงค์ที่เกี่ยวข้องกับนโยบายฉบับนี้ ซึ่งอาจจำเป็นต้องเก็บรักษาไว้ต่อไปภายหลังจากนั้น หากมีกฎหมายกำหนดไว้ เราจะลบ ทำลาย หรือทำให้เป็นข้อมูลที่ไม่สามารถระบุตัวตนของคุณได้ เมื่อหมดความจำเป็นหรือสิ้นสุดระยะเวลาดังกล่าว</p>

                <h4>สิทธิของเจ้าของข้อมูลส่วนบุคคล</h4>
                <p>ภายใต้กฎหมายคุ้มครองข้อมูลส่วนบุคคล คุณมีสิทธิในการดำเนินการดังต่อไปนี้</p>
                <p>สิทธิขอถอนความยินยอม (right to withdraw consent) หากคุณได้ให้ความยินยอม เราจะเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลของคุณ ไม่ว่าจะเป็นความยินยอมที่คุณให้ไว้ก่อนวันที่กฎหมายคุ้มครองข้อมูลส่วนบุคคลใช้บังคับหรือหลังจากนั้น คุณมีสิทธิที่จะถอนความยินยอมเมื่อใดก็ได้ตลอดเวลา</p>
                <p>สิทธิขอเข้าถึงข้อมูล (right to access) คุณมีสิทธิขอเข้าถึงข้อมูลส่วนบุคคลของคุณที่อยู่ในความรับผิดชอบของเราและขอให้เราทำสำเนาข้อมูลดังกล่าวให้แก่คุณ รวมถึงขอให้เราเปิดเผยว่าเราได้ข้อมูลส่วนบุคคลของคุณมาได้อย่างไร</p>
                <p>สิทธิขอถ่ายโอนข้อมูล (right to data portability) คุณมีสิทธิขอรับข้อมูลส่วนบุคคลของคุณในกรณีที่เราได้จัดทำข้อมูลส่วนบุคคลนั้นอยู่ในรูปแบบให้สามารถอ่านหรือใช้งานได้ด้วยเครื่องมือหรืออุปกรณ์ที่ทำงานได้โดยอัตโนมัติและสามารถใช้หรือเปิดเผยข้อมูลส่วนบุคคลได้ด้วยวิธีการอัตโนมัติ รวมทั้งมีสิทธิขอให้เราส่งหรือโอนข้อมูลส่วนบุคคลในรูปแบบดังกล่าวไปยังผู้ควบคุมข้อมูลส่วนบุคคลอื่นเมื่อสามารถทำได้ด้วยวิธีการอัตโนมัติ และมีสิทธิขอรับข้อมูลส่วนบุคคลที่เราส่งหรือโอนข้อมูลส่วนบุคคลในรูปแบบดังกล่าวไปยังผู้ควบคุมข้อมูลส่วนบุคคลอื่นโดยตรง เว้นแต่ไม่สามารถดำเนินการได้เพราะเหตุทางเทคนิค</p>
                <p>สิทธิขอคัดค้าน (right to object)
                    คุณมีสิทธิขอคัดค้านการเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลของคุณในเวลาใดก็ได้ หากการเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลของคุณที่ทำขึ้นเพื่อการดำเนินงานที่จำเป็นภายใต้ประโยชน์โดยชอบด้วยกฎหมายของเราหรือของบุคคลหรือนิติบุคคลอื่น โดยไม่เกินขอบเขตที่คุณสามารถคาดหมายได้อย่างสมเหตุสมผลหรือเพื่อดำเนินการตามภารกิจเพื่อสาธารณประโยชน์</p>
                <p>สิทธิขอให้ลบหรือทำลายข้อมูล (right to erasure/destruction) คุณมีสิทธิขอลบหรือทำลายข้อมูลส่วนบุคคลของคุณหรือทำให้ข้อมูลส่วนบุคคลเป็นข้อมูลที่ไม่สามารถระบุตัวคุณได้ หากคุณเชื่อว่าข้อมูลส่วนบุคคลของคุณถูกเก็บรวบรวม ใช้ หรือเปิดเผยโดยไม่ชอบด้วยกฎหมายที่เกี่ยวข้องหรือเห็นว่าเราหมดความจำเป็นในการเก็บรักษาไว้ตามวัตถุประสงค์ที่เกี่ยวข้องในนโยบายฉบับนี้ หรือเมื่อคุณได้ใช้สิทธิขอถอนความยินยอมหรือใช้สิทธิขอคัดค้านตามที่แจ้งไว้ข้างต้นแล้ว</p>
                <p>สิทธิขอให้ระงับการใช้ข้อมูล (right to restriction of processing) คุณมีสิทธิขอให้ระงับการใช้ข้อมูลส่วนบุคคลชั่วคราวในกรณีที่เราอยู่ระหว่างตรวจสอบตามคำร้องขอใช้สิทธิขอแก้ไขข้อมูลส่วนบุคคลหรือขอคัดค้านของคุณหรือกรณีอื่นใดที่เราหมดความจำเป็นและต้องลบหรือทำลายข้อมูลส่วนบุคคลของคุณตามกฎหมายที่เกี่ยวข้องแต่คุณขอให้เราระงับการใช้แทน</p>
                <p>สิทธิขอให้แก้ไขข้อมูล (right to rectification) คุณมีสิทธิขอแก้ไขข้อมูลส่วนบุคคลของคุณให้ถูกต้อง เป็นปัจจุบัน สมบูรณ์ และไม่ก่อให้เกิดความเข้าใจผิด</p>
                <p>สิทธิร้องเรียน (right to lodge a complaint) คุณมีสิทธิร้องเรียนต่อผู้มีอำนาจตามกฎหมายที่เกี่ยวข้อง หากคุณเชื่อว่าการเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลของคุณ เป็นการกระทำในลักษณะที่ฝ่าฝืนหรือไม่ปฏิบัติตามกฎหมายที่เกี่ยวข้อง</p>
                <p>คุณสามารถใช้สิทธิของคุณในฐานะเจ้าของข้อมูลส่วนบุคคลข้างต้นได้ โดยติดต่อมาที่เจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคลของเราตามรายละเอียดท้ายนโยบายนี้ เราจะแจ้งผลการดำเนินการภายในระยะเวลา 30 วัน นับแต่วันที่เราได้รับคำขอใช้สิทธิจากคุณ ตามแบบฟอร์มหรือวิธีการที่เรากำหนด ทั้งนี้ หากเราปฏิเสธคำขอเราจะแจ้งเหตุผลของการปฏิเสธให้คุณทราบผ่านช่องทางต่าง ๆ เช่น ข้อความ (SMS) อีเมล โทรศัพท์ จดหมาย เป็นต้น</p>

                <h4>เทคโนโลยีติดตามตัวบุคคล (Cookies)</h4>
                <p>เพื่อเพิ่มประสบการณ์การใช้งานของคุณให้สมบูรณ์และมีประสิทธิภาพมากขึ้น เราใช้คุกกี้ (Cookies)หรือเทคโนโลยีที่คล้ายคลึงกัน เพื่อพัฒนาการเข้าถึงสินค้าหรือบริการ โฆษณาที่เหมาะสม และติดตามการใช้งานของคุณ เราใช้คุกกี้เพื่อระบุและติดตามผู้ใช้งานเว็บไซต์และการเข้าถึงเว็บไซต์ของเรา หากคุณไม่ต้องการให้มีคุกกี้ไว้ในคอมพิวเตอร์ของคุณ คุณสามารถตั้งค่าบราวเซอร์เพื่อปฏิเสธคุกกี้ก่อนที่จะใช้เว็บไซต์ของเราได้</p>
                <h4>การรักษาความมั่งคงปลอดภัยของข้อมูลส่วนบุคคล</h4>
                <p>เราจะรักษาความมั่นคงปลอดภัยของข้อมูลส่วนบุคคลของคุณไว้ตามหลักการ การรักษาความลับ (confidentiality) ความถูกต้องครบถ้วน (integrity) และสภาพพร้อมใช้งาน (availability) ทั้งนี้ เพื่อป้องกันการสูญหาย เข้าถึง ใช้ เปลี่ยนแปลง แก้ไข หรือเปิดเผย นอกจากนี้เราจะจัดให้มีมาตรการรักษาความมั่นคงปลอดภัยของข้อมูลส่วนบุคคล ซึ่งครอบคลุมถึงมาตรการป้องกันด้านการบริหารจัดการ (administrative safeguard) มาตรการป้องกันด้านเทคนิค (technical safeguard) และมาตรการป้องกันทางกายภาพ (physical safeguard) ในเรื่องการเข้าถึงหรือควบคุมการใช้งานข้อมูลส่วนบุคคล (access control)</p>

                <h4>การแจ้งเหตุละเมิดข้อมูลส่วนบุคคล</h4>
                <p>ในกรณีที่มีเหตุละเมิดข้อมูลส่วนบุคคลของคุณเกิดขึ้น เราจะแจ้งให้สำนักงานคณะกรรมการคุ้มครองข้อมูลส่วนบุคคลทราบโดยไม่ชักช้าภายใน 72 ชั่วโมง นับแต่ทราบเหตุเท่าที่สามารถกระทำได้ ในกรณีที่การละเมิดมีความเสี่ยงสูงที่จะมีผลกระทบต่อสิทธิและเสรีภาพของคุณ เราจะแจ้งการละเมิดให้คุณทราบพร้อมกับแนวทางการเยียวยาโดยไม่ชักช้าผ่านช่องทางต่าง ๆ เช่น เว็บไซต์ ข้อความ (SMS) อีเมล โทรศัพท์ จดหมาย เป็นต้น</p>
                <h4>การแก้ไขเปลี่ยนแปลงนโยบายความเป็นส่วนตัว</h4>
                <p>เราอาจแก้ไขเปลี่ยนแปลงนโยบายนี้เป็นครั้งคราว โดยคุณสามารถทราบข้อกำหนดและเงื่อนไขนโยบายที่มีการแก้ไขเปลี่ยนแปลงนี้ได้ผ่านทางเว็บไซต์ของเรา
                    นโยบายนี้แก้ไขล่าสุดและมีผลใช้บังคับตั้งแต่วันที่ 10 พฤษภาคม 2564</p>
                <h4>นโยบายความเป็นส่วนตัวของเว็บไซต์อื่น</h4>
                <p>นโยบายความเป็นส่วนตัวฉบับนี้ใช้สำหรับการเสนอสินค้า บริการ และการใช้งานบนเว็บไซต์สำหรับลูกค้าของเราเท่านั้น หากคุณเข้าชมเว็บไซต์อื่นแม้จะผ่านช่องทางเว็บไซต์ของเรา การคุ้มครองข้อมูลส่วนบุคคลต่าง ๆ จะเป็นไปตามนโยบายความเป็นส่วนตัวของเว็บไซต์นั้น ซึ่งเราไม่มีส่วนเกี่ยวข้องด้วย</p>
                <h4>รายละเอียดการติดต่อ</h4>
                <p>หากคุณต้องการสอบถามข้อมูลเกี่ยวกับนโยบายความเป็นส่วนตัวฉบับนี้ รวมถึงการขอใช้สิทธิต่าง ๆ คุณสามารถติดต่อเราหรือเจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคลของเราได้ ดังนี้</p>
                <h4>ผู้ควบคุมข้อมูลส่วนบุคคล</h4>
                <p>บริษัทฯ ผู้ให้บริการระบบบริหารแฟรนไชส์ ณ ให้จุดบริการ</p>
            </div>
            <div class="d-flex justify-content-center mt-4">
                <b-button
                    class="px-5"
                    variant="primary"
                    @click="ProtocolPrivacy = false"
                >
                    ยืนยัน
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import upload from '@/views/newPages/upload.vue'
import {certAgentSender} from "@/api/storeManage";
export default {
    components: {
        upload
    },
    data() {
        return {
            ProtocolPrivacy: false,
            imgUrl: '',
            ruleForm: {},
            options: [
                { text: '身份证', value: '1' },
                { text: '护照', value: '2' }
            ]
        }
    },
    methods: {
        onSubmit(evt) {
            evt.preventDefault()
            console.log(this.ruleForm)
            let imgTips = ''
            if (this.ruleForm.certType === '1' && !this.ruleForm.idcardPicFront) {
                imgTips = '请上传身份证正面照片'
            } else if (this.ruleForm.certType === '2' && !this.ruleForm.passportPic) {
                imgTips = '请上传护照照片'
            }
            if (imgTips) {
                this.$bvModal.msgBoxOk(imgTips, {
                    title: "ERROR",
                    size: "sm",
                    buttonSize: "sm",
                    okVariant: "danger",
                    okTitle: "คำใบ้",
                    contentClass: "modal-errors",
                    headerClass: "p-2 border-bottom-0",
                    footerClass: "p-2 border-top-0",
                    centered: true
                });
                return
            }

            let data = {
                certType: this.ruleForm.certType,
                country: "TH",
                idCardTerm: "10",
                mobile: this.ruleForm.idcardTel,
                name: this.ruleForm.idcardName,
                idCardNum: this.ruleForm.idcardNum,
                idCardPicFront: this.ruleForm.idcardPicFront,
                // code: this.ruleForm.idcardVercode,
                id: this.ruleForm.id,
                passportNum: this.ruleForm.passportNum,
                passportPic: this.ruleForm.passportPic,
                passportTerm: "10",
            };
            certAgentSender(data).then(res => {
                this.$bvModal.msgBoxOk("ส่งเรียบร้อยแล้ว", {
                    title: "SUCCESS",
                    size: "sm",
                    buttonSize: "sm",
                    okVariant: "success",
                    okTitle: "ตกลง",
                    contentClass: "modal-success",
                    headerClass: "p-2 border-bottom-0",
                    footerClass: "p-2 border-top-0",
                    centered: true
                });
            })
        },
        updateImage(val) {
            if (this.ruleForm.certType === '1') {
                this.ruleForm.idcardPicFront = val
            } else if (this.ruleForm.certType === '2') {
                this.ruleForm.passportPic = val
            }
            this.imgUrl = val

        },
    }


}
</script>

<style scoped>
.noticeContent{
    height: 60vh;
    overflow: auto;
}
.noticeContent h3{
    font-size: 20px;
    line-height:36px;
    color: #303133;
    text-align: center;
}
.noticeContent p{
    line-height:28px;
    color: #606266;
}
.noticeContent h4{
    font-size: 16px;
    display: inline;
    font-weight: 600;
    line-height:36px;
    color: #303133;
}
</style>
